import { SendStatus } from '../../models/sendStatus';
import { ManufacturerStatus, OrderStatus } from '../../models/orderStatus';
import {
  MANUFACTURER_OPTIONS,
  UNKNOWN_MANUFACTURER,
  Manufacturer,
} from '../types';
import { isValidManufacturer } from './orderItems';
import { Item } from '../../models/item';

/**
 * Return status for every provided manufacturer:
 * - if there are no items from manufacturer - it is not included
 * - if data about manufacturer is not included in `statusObject`,
 *   then status is `not-sent`
 * - if manufacturer is unknown - skip item
 *
 * @param statusObject
 * @param groupedItems
 */
export function getActualOrderStatus(statusObject: OrderStatus, groupedItems: Record<Manufacturer, Item[]>) {
  const status: OrderStatus = {};

  MANUFACTURER_OPTIONS
    .filter(man => groupedItems[man]?.length > 0)
    .forEach(man => {
      const manStatus = statusObject ? statusObject[man] : null;
      status[man] = manStatus || { status: SendStatus.notSent };
  });

  return status as OrderStatus;
}

/**
 * Check if emails have been sent to all manufacturers
 * @param sendStatusObject
 * @param manufacturers
 * @return {*}
 */
export function isSentToAllManufacturers(sendStatusObject: OrderStatus) {
  return Object.keys(sendStatusObject)
    .map((man: Manufacturer | typeof UNKNOWN_MANUFACTURER) => {
      return (
        man === UNKNOWN_MANUFACTURER ||
        !isValidManufacturer(man) ||
        sendStatusObject[man]?.status === SendStatus.sent
      );
    })
    .reduce((a, b) => a && b, true);
}

export function getStatusNotes(statusObject: OrderStatus) {
  const notes: Record<Manufacturer, ManufacturerStatus['notes']> = { "mk socks": undefined, "pearsox": undefined };
  if (statusObject) {
    Object.keys(statusObject).forEach((man: Manufacturer) => {
      notes[man] = statusObject[man] ? statusObject[man].notes : undefined;
    });
  }
  return notes;
}

export function getStatusMessage(status: SendStatus) {
  switch (status) {
    case SendStatus.sent:
      return 'All items sent';
    case SendStatus.notSent:
      return 'Items not sent';
    case SendStatus.failedToSend:
      return 'Failed to send items';
    default:
      console.error(`Unexpected status ${status} for manufacturer`);
      return '';
  }
}
